/**
 * Routes auth — `/login`, `/signup`, `/activate-account` (publiques, AuthLayout).
 */

import type { RouteObject } from 'react-router-dom';
import { lazy } from 'react';

const LoginView = lazy(() => import('./views/LoginView').then((m) => ({ default: m.LoginView })));
const SignUpView = lazy(() =>
  import('./views/SignUpView').then((m) => ({ default: m.SignUpView })),
);
const VerifyEmailView = lazy(() =>
  import('./views/VerifyEmailView').then((m) => ({ default: m.VerifyEmailView })),
);
const EmailSentView = lazy(() =>
  import('./views/EmailSentView').then((m) => ({ default: m.EmailSentView })),
);
const ForgotPasswordView = lazy(() =>
  import('./views/ForgotPasswordView').then((m) => ({ default: m.ForgotPasswordView })),
);
const ResetPasswordView = lazy(() =>
  import('./views/ResetPasswordView').then((m) => ({ default: m.ResetPasswordView })),
);

export const authRoutes: RouteObject[] = [
  {
    path: 'login',
    element: <LoginView />,
    handle: { title: 'Connexion', public: true },
  },
  {
    path: 'signup',
    element: <SignUpView />,
    handle: { title: 'Inscription', public: true },
  },
  {
    // Path aligned with the activation link built by ms-notification
    // (`${FRONTEND_URL}/activate-account?token=...`). The backend endpoint
    // hit by this view stays `PATCH /api/auth/verify-email` (gateway contract).
    path: 'activate-account',
    element: <VerifyEmailView />,
    handle: { title: 'Activation du compte', public: true },
  },
  {
    path: 'email-sent',
    element: <EmailSentView />,
    handle: { title: 'Email envoyé', public: true },
  },
  {
    path: 'forgot-password',
    element: <ForgotPasswordView />,
    handle: { title: 'Mot de passe oublié', public: true },
  },
  {
    // Path aligned with the reset link built by ms-notification
    // (`${FRONTEND_URL}/reset-password?token=...`). The backend endpoint hit by
    // this view is `PATCH /api/users/reset-password` (gateway contract).
    path: 'reset-password',
    element: <ResetPasswordView />,
    handle: { title: 'Réinitialisation du mot de passe', public: true },
  },
];
